import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Bed, Bath, Square, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/site/Reveal";
import { API, BACKEND_URL, formatPrice } from "@/lib/site";

export default function ProjectTeaser() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get(`${API}/projects`).then((r) => setProjects(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (projects.length === 0) return null;

  return (
    <section id="projek" data-testid="project-teaser" className="py-24 md:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
                <Building2 className="h-4 w-4" /> Projek Perumahan
              </span>
              <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
                Projek pilihan terkini
              </h2>
              <p className="mt-3 text-slate-600">
                Terokai projek perumahan yang saya uruskan. Hubungi saya untuk butiran lanjut.
              </p>
            </div>
            <Link to="/projek" data-testid="project-teaser-all-btn">
              <Button variant="outline" className="rounded-full border-slate-300 text-[#0A2540] hover:bg-slate-50">
                Lihat semua projek <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((p, i) => {
            const cover = p.images && p.images.length > 0 ? `${BACKEND_URL}/api/projects/${p.id}/images/0` : "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=80&w=800";
            const price = p.price_to ? `RM ${formatPrice(p.price_from)} - ${formatPrice(p.price_to)}` : p.price_from ? `Dari RM ${formatPrice(p.price_from)}` : "Atas permintaan";
            return (
              <Reveal key={p.id} delay={i * 0.08}>
                <Link to={`/projek/${p.slug}`} data-testid={`teaser-project-${p.slug}`}
                  className="group flex flex-col h-full rounded-2xl border border-slate-200 overflow-hidden transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#1D4ED8]">
                  <div className="relative h-48 bg-slate-100 overflow-hidden">
                    <img src={cover} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                    {p.status && <span className="absolute top-3 left-3 rounded-full bg-white/95 backdrop-blur px-3 py-1 text-xs font-semibold text-[#0A2540]">{p.status}</span>}
                  </div>
                  <div className="flex flex-col flex-1 p-6">
                    <h3 className="font-heading text-lg font-bold text-[#0A2540] leading-snug">{p.title}</h3>
                    {p.location && <p className="mt-1 flex items-center gap-1 text-sm text-slate-500"><MapPin className="h-3.5 w-3.5" /> {p.location}</p>}
                    <p className="mt-3 font-heading text-base font-bold text-[#1D4ED8]">{price}</p>
                    <div className="mt-3 flex items-center gap-4 text-xs text-slate-500">
                      {p.bedrooms && <span className="flex items-center gap-1"><Bed className="h-3.5 w-3.5" /> {p.bedrooms}</span>}
                      {p.bathrooms && <span className="flex items-center gap-1"><Bath className="h-3.5 w-3.5" /> {p.bathrooms}</span>}
                      {p.built_up && <span className="flex items-center gap-1"><Square className="h-3.5 w-3.5" /> {p.built_up}</span>}
                    </div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
